import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./PatientsUIHelpers";

const PatientssUIContext = createContext();

export function usePatientsUIContext() {
  return useContext(PatientssUIContext);
}

export const PatientsUIConsumer = PatientssUIContext.Consumer;

export function PatientsUIProvider({ patientsUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams, 
    openDetailPatientPage: patientsUIEvents.openDetailPatientPage
  };

  return (
    <PatientssUIContext.Provider value={value}>
      {children}
    </PatientssUIContext.Provider>
  );
}
